import React from "react";

const Title = props => <h1 className="tit left m_visible large_font">{ props.children }</h1>;

export default Title;
